export enum EmergencyAlarmDeviceTriggerAction {
  OnePress = 'OnePress',
  TwoPresses = 'TwoPresses',
}
